import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";

export default class PageMyPatches
{
    constructor(_targetElement)
    {
        this.projects = web.projects;

        this._settings = {
            "lastFilter": "all",
            "lastOrder": "updated"
        };

        const url = new URL(window.location.href);
        const order = url.searchParams.get("or") || "updated";
        if (order)
        {
            const orderTabs = ele.byQueryAll("#order-tab-bar li");
            orderTabs.forEach((orderTab) =>
            {
                if (orderTab.classList.contains(order)) orderTab.classList.add("active");
            });
        }
    }

    get lastFilter()
    {
        return this._settings.lastFilter;
    }

    getMyPatches(targetEl, fromUserInteraction = false)
    {
        if (typeof targetEl === "string")
        {
            const selector = ".tab-bar-content[data-tab-name=\"" + targetEl + "\"]";
            targetEl = ele.byQuery(selector);
        }
        let filter = "";
        if (window.location.hash)
        {
            filter = window.location.hash.split("#", 2)[1];
        }
        const url = new URL(window.location.href);

        filter = filter || url.searchParams.get("w") || "all";
        const order = url.searchParams.get("or") || "updated";
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o");
        limit = Number(limit);
        offset = Number(offset);

        this._settings.lastFilter = filter;
        this._settings.lastOrder = order;

        let apiUrl = "mypatches?filter=" + filter + "&sort=" + order;

        if (limit || limit === 0)
        {
            apiUrl += "&l=" + limit;
        }
        if (offset)
        {
            apiUrl += "&o=" + offset;
        }
        api.get(apiUrl, (result) =>
        {
            const tagArr = this.projects.getTagsFromProjects(result);
            const tagsEle = ele.byId("tags");
            if (tagsEle)
            {
                web.setHandleBarHtml("tags", { "tags": tagArr }, tagsEle);
            }

            let html = "";
            html += "<div class=\"row\">";
            for (const i in result.patches)
            {
                const project = result.patches[i];
                let displayedDate = "updated";
                if (order === "created") displayedDate = "created";
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername }, "displayedDate": displayedDate });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            html += "</div>";
            targetEl.innerHTML = html;
            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId("my-projects"), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    this.setUrl(filter, order, newLimit, newOffset);
                });
            }
        });
    }

    setUrl(filter, order, limit, offset)
    {
        let newSearch = "";
        if (order)
        {
            newSearch += newSearch ? "&" : "?";
            newSearch += "or=" + order;
        }
        if (limit || limit === 0)
        {
            newSearch += newSearch ? "&" : "?";
            newSearch += "l=" + limit;
        }
        if (offset)
        {
            newSearch += newSearch ? "&" : "?";
            newSearch += "o=" + offset;
        }
        window.location.search = newSearch;
        history.pushState(null, null, "#" + filter);
    }
}
